module.exports = __webpack_public_path__ + "static/flags/JO-9dc39a0ae0119005e407baad494c7950.gif";